import React from 'react'
import { FormDate } from '@myxplor/forms'
import DefaultForm from '../../../../ui/forms/default-form'
import { momentFromDate } from '../../../../week'

const yesterday = () =>
  momentFromDate()
    .startOf('day')
    .subtract(1, 'day')

const available = ({ available_actions }) => (available_actions || []).includes('end_enrolment')

const apiEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/ccs-enrolments/${gov_id}/end-enrolment`

const formValue = 'end_ccs_enrolment'

const FormComponent = ({ record, values, errors, onChange }) => (
  <fieldset>
    Are you sure you want to end this Government Enrolment for{' '}
    {record.gov_record.ChildFirstName || 'this child'}?
    <FormDate
      name="end_date"
      label="End Date"
      value={values.end_date}
      hint="Date to end CCS government enrolment"
      onChange={onChange}
      errors={errors.endDate}
    />
  </fieldset>
)

export const actionForm = ({ record }) => ({ handleSuccess }) => (
  <DefaultForm
    url={apiEndPoint(record)}
    name={formValue}
    label="Save"
    handleSuccess={() => handleSuccess({ [formValue]: 'This enrolment has been ended' }, formValue)}
    formOptions={{ defaultValues: { end_date: yesterday() } }}
    formComponent={props => <FormComponent record={record} {...props} />}
  />
)

export const endEnrolment = ({ record, refresh_enrolments }) =>
  available(record)
    ? {
      label: 'End CCS Enrolment',
      value: formValue,
      actionForm: actionForm({ record }),
      onComplete: refresh_enrolments,
    }
    : null



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/end-enrolment.js